import * as types from '../actions/action-types';

export function apps(state = {list: {}, openApp: null}, action) {
  switch (action.type) {
    case types.REQUEST_APP:
      return {...state, list: {...state.list, [action.slug]: {isFetching: true, data: {}}}};
    case types.RECEIVE_APP:
      return {...state, list: {...state.list, [action.slug]: {isFetching: false, data: action.data, receivedAt: action.receivedAt}}};
    case types.OPEN_APP:
      return {...state, openApp: action.slug};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/apps.js